<ms-header-content
    [event]="event"
    [live]="event.scoreboard.started"
    [feature]="feature"
    [isNewEDPScoreboard]="isNewEDPScoreboard"
    (toggle)="densityToggled($event)"
    (videoPinToggle)="onVideoPinToggle($event)"></ms-header-content>
<ng-container *ngIf="!isSitemapEnabled; else sitemapTemplate">
    <ms-event-header-tabs
        *ngIf="!event.isFinished() && setTabs?.length > 1"
        [tabs]="setTabs"
        [event]="event"
        (activeTab)="setTabSelected($event)"></ms-event-header-tabs>
</ng-container>
<ms-header-sub-navigation
    *ngIf="!isSitemapEnabled && setTabs?.length && isHeaderSubNavigationEnabled"
    [tabs]="setTabs"
    (tabChange)="tabClicked($event)">
</ms-header-sub-navigation>
<ng-template #sitemapTemplate>
    <ng-container *ngIf="setTabs">
        <ng-container *msComponentProxy="sitemapComponent"></ng-container>
    </ng-container>
</ng-template>
